/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { accountId } from '../../utils/auth';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_JAVA_SERVICE_HOST,
  withCredentials: true,
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  function (config: any) {


    // Replace placeholder {accountId} if needed
    if (config.baseURL && accountId) {
      config.baseURL = config.baseURL.replace("{accountId}", accountId);
    }

    return config;
  },
  function (error: any) {
    return Promise.reject(error);
  },
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  function (response: any) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response;
  },
  function (error: any) {
    const status = error?.response?.status;
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error;
      if (status === 401 || status === 302 || error?.response?.type === "opaqueredirect") {
      localStorage.setItem("isSignedOutOrTokenExpired", JSON.stringify(true));
      sessionStorage.clear();
      const isSessionExpired = message === "Your session has expired. Please log in again." ||  message === "TOKEN_REVOKED";

      if(isSessionExpired) {
        if (!window.location.pathname.includes("/login")) {
          window.location.href = "/login";
        }
      } else {
        window.location.href = import.meta.env.VITE_APP_UNAUTHORIZED_USER_LOGOUT;
      }
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;